import { React, useState } from 'react'
// import Avatar from '@mui/material/Avatar';
// import Button from '@mui/material/Button';
// import CssBaseline from '@mui/material/CssBaseline';
// import TextField from '@mui/material/TextField';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import Checkbox from '@mui/material/Checkbox';
// import Box from '@mui/material/Box';
// import Typography from '@mui/material/Typography';
// import Container from '@mui/material/Container';
// import Link from '@mui/material/Link';
import axios from "axios";
import { API_URL } from '../../api-config';
import { toast } from 'react-toastify';



const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const handleForceLogin = () => {
    const lowerCaseMail = email.toLowerCase();
    axios.post(`${API_URL}/forcetoken`, `grant_type=&username=${lowerCaseMail}&password=${password}&scope=&client_id=&client_secret=`, { headers: { "Content-Type": "application/x-www-form-urlencoded" } })
      .then((e) => {
        toast.success('Inicio de sesión exitoso!', { position: toast.POSITION.TOP_RIGHT });
        localStorage.setItem("token", e.data.access_token);
        window.location.assign("/");
      })
      .catch((error) => {
        console.log(`Error (forced login) ${error}`);
        setErrorMessage('No se pudo forzar el inicio de sesión. Inténtelo de nuevo.');
      });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const lowerCaseMail = email.toLowerCase();
    axios.post(`${API_URL}/users-api/auth/token/`, `grant_type=&username=${lowerCaseMail}&password=${password}&scope=&client_id=&client_secret=`, { headers: { "Content-Type": "application/x-www-form-urlencoded" } })
      .then((e) => {
        toast.success('Inicio de sesión exitoso!', { position: toast.POSITION.TOP_RIGHT });
        localStorage.setItem("token", e.data.access_token);
        window.location.assign("/");
      })
      .catch((error) => {
        console.log('error', error)
        if (error.response && error.response.status === 403 && error.response.data.detail === "Another user is already using this account") {
          if (window.confirm("Hay otro usuario utilizando esta cuenta. ¿Quieres expulsarlo?")) {
            handleForceLogin();
          }
        } else {
          console.log(`Error ${error}`);
          setErrorMessage('El usuario y/o la contraseña son incorrectos');
        }
      });
  };

  return (
    <div className="flex justify-center items-center p-2 h-full w-full">
      <div className="max-w-xs w-full">
        <div className="flex flex-col items-center w-full">
          <div className="flex justify-center items-center mb-6">
            <span className="text-2xl font-bold text-white tracking-wide">QRT Trading Webtool</span>
          </div>
          <h1 className="text-xl text-gray-200 font-medium mb-8">Iniciar Sesión</h1>
          <form className="w-full" onSubmit={handleSubmit} noValidate>
            <div className="mb-5">
              <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-1.5">
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                required
                className="p-3 w-full text-white bg-black/20 border border-white/10 rounded-lg focus:border-[#009cd0] focus:ring-1 focus:ring-[#009cd0] outline-none transition-all placeholder-gray-500"
              />
            </div>
            <div className="mb-6">
              <label htmlFor="password" className="block text-sm font-medium text-gray-300 mb-1.5">
                Contraseña
              </label>
              <input
                type="password"
                id="password"
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
                className="p-3 w-full text-white bg-black/20 border border-white/10 rounded-lg focus:border-[#009cd0] focus:ring-1 focus:ring-[#009cd0] outline-none transition-all placeholder-gray-500"
              />
            </div>
            {errorMessage && <p className="text-red-400 text-sm mb-4">{errorMessage}</p>}
            <div className="flex items-center mb-6">
              <input
                type="checkbox"
                id="remember"
                name="remember"
                className="h-4 w-4 rounded bg-[#0b0e17]/80 border-white/20 text-[#009cd0] focus:ring-[#009cd0]"
              />
              <label htmlFor="remember" className="ml-2 text-sm text-gray-300">
                Recordarme
              </label>
            </div>
            <a href="/forgot_password" >
              {/* <Link to="/forgot_password" className="text-sm text-gray-700 hover:text-blue-500 underline py-4">
                Olvidé mi contraseña
              </Link> */}
            </a>
            <button
              type="submit"
              className="w-full py-3 mt-2 px-4 bg-gradient-to-r from-[#009cd0] to-[#006ae8] text-white font-bold rounded-lg hover:opacity-90 transition-opacity shadow-[0_0_20px_rgba(0,156,208,0.5)]"
            >
              Iniciar Sesión
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Login
